function handleScroll() {
  let parent = document.querySelector(".c-blog-article__image");
  let child = document.querySelector(".c-blog-article__image-sticky");
  if(!parent || !child) return;
  let crossChildHeight = 0;
  if (child.clientHeight > parent.getBoundingClientRect().bottom) {
    crossChildHeight =
    parent.getBoundingClientRect().bottom - child.clientHeight;
  }
  if (parseInt(parent.getBoundingClientRect().bottom) < 0) {
    child.style.opacity = "0";
  } else {
    child.style.opacity = "1";
  }
}
document.addEventListener("scroll", handleScroll);